// REDESIGN 2024

// sentry je zatím zakomentované - build procházel, i když nebylo nainstalované @sentry/browser, což rozbíjelo produkci (přestávalo fungovat jQuery)
// !!! import * as Sentry from '@sentry/browser';

const navigationInit = async () => {
    const navigationElement: HTMLElement | null = document.querySelector('[data-navigation]');

    if (navigationElement) {
        const { navigation } = await import(
            /* webpackChunkName: 'chunk-navigation' */
            './components/navigation/navigation.ts'
        );

        navigation(navigationElement);
    }
};

export const swiperInit = async () => {
    const swiperSelectors: NodeListOf<HTMLElement> = document.querySelectorAll('[data-swiper]');

    if (swiperSelectors.length > 0) {
        const { swiper } = await import(
            /* webpackChunkName: 'chunk-swiper' */
            './components/swiper.ts'
        );

        for (const swiperSelector of swiperSelectors) {
            if (swiperSelector instanceof HTMLDivElement) swiper(swiperSelector);
        }
    }
};

// Součást navigace
const dynamicNavigationInit = async () => {
    const dynamicNavigationTemplate: HTMLTemplateElement | null = document.querySelector(
        '[data-dynamic-navigation-template]',
    );

    if (dynamicNavigationTemplate) {
        const { dynamicNavigation } = await import(
            /* webpackChunkName: 'chunk-dynamicNavigation' */
            './components/navigation/dynamicNavigation.ts'
        );

        dynamicNavigation(dynamicNavigationTemplate);

        swiperInit();
    }
};

// Součást navigace
const infoStripInit = async () => {
    const infoStripElement: HTMLElement | null = document.querySelector('[data-info-strip]');

    if (infoStripElement) {
        const { infoStrip } = await import(
            /* webpackChunkName: 'chunk-infoStrip' */
            './components/navigation/infoStrip.ts'
        );
        infoStrip({
            infoStripElement,
        });
    }
};

const breakingNewsInit = async () => {
    const breakingNewsTemplate: HTMLTemplateElement | null = document.querySelector(
        '[data-breaking-news-template]',
    );

    if (breakingNewsTemplate) {
        const { breakingNews } = await import(
            /* webpackChunkName: 'chunk-breakingNews' */
            './components/navigation/breakingNews/breakingNews.ts'
        );

        breakingNews(breakingNewsTemplate);
    }
};

const giftsAIInit = async () => {
    const giftsAIFormElement: HTMLFormElement | null =
        document.querySelector('[data-gifts-ai-form]');

    if (giftsAIFormElement) {
        const { giftsAI } = await import(
            /* webpackChunkName: 'chunk-giftsAI' */
            './components/giftsAI/giftsAi.ts'
        );
        giftsAI({ form: giftsAIFormElement });
    }
};

const atomicDesignInit = async () => {
    const articleGalleryBigElement: HTMLElement | null =
        document.querySelector('[data-atomic-design]');

    if (articleGalleryBigElement) {
        const { atomicDesign } = await import(
            /* webpackChunkName: 'chunk-atomicDesign' */
            './modules/atomic-design/atomicDesign.ts'
        );

        atomicDesign();
    }
};

const contentExpanderInit = async () => {
    const contentExpanderElements: NodeListOf<HTMLElement> =
        document.querySelectorAll('[data-content-expander]');

    if (contentExpanderElements.length > 0) {
        const { contentExpander } = await import(
            /* webpackChunkName: 'chunk-contentExpander' */
            './components/contentExpander.ts'
        );

        contentExpander(contentExpanderElements);
    }
};

const formTextareaInit = async () => {
    const textAreaWrappers: NodeListOf<HTMLDivElement> =
        document.querySelectorAll('[data-form-textarea]');

    if (textAreaWrappers) {
        const { formTextarea } = await import(
            /* webpackChunkName: 'chunk-formTextarea' */
            './element/form/formTextarea.ts'
        );

        formTextarea({ textAreaWrappers });
    }
};

const tooltipInit = async () => {
    const tooltipElements: NodeListOf<HTMLElement> = document.querySelectorAll('[data-tooltip]');

    if (tooltipElements.length > 0) {
        const { tooltip } = await import(
            /* webpackChunkName: 'chunk-tooltip' */
            './element/tooltip.ts'
        );
        tooltip(tooltipElements);
    }
};

const footerLinkListInit = async () => {
    const footerLinkListElements: NodeListOf<HTMLElement> =
        document.querySelectorAll('[data-footer-link-list]');
    if (footerLinkListElements.length > 0) {
        const { footerLinkList } = await import(
            /* webpackChunkName: 'chunk-footerLinkList' */
            './components/footerLinkList.ts'
        );
        footerLinkList(footerLinkListElements);
    }
};

const footerInit = async () => {
    const footerElement: HTMLElement | null = document.querySelector('[data-footer]');
    if (footerElement) {
        const { footer } = await import(
            /* webpackChunkName: 'chunk-footer' */
            './components/footer.ts'
        );
        footer(footerElement);
    }
};

const articleCardListAutoloadInit = async () => {
    const articleCardListAutoloadElements: NodeListOf<HTMLElement> = document.querySelectorAll(
        '[data-article-card-list-autoload]',
    );
    if (articleCardListAutoloadElements.length > 0) {
        const { articleCardListAutoload } = await import(
            /* webpackChunkName: 'chunk-articleCardListAutoload' */
            './components/articleCardListAutoLoad.ts'
        );
        articleCardListAutoload(articleCardListAutoloadElements);
    }
};

const advertisementRightColumInit = async () => {
    const advertisementRightColumElement: HTMLElement | null = document.querySelector(
        '[data-advertisement-right-column]',
    );

    if (advertisementRightColumElement) {
        const { advertisementRightColum } = await import(
            /* webpackChunkName: 'chunk-advertisementRightColumn' */
            './components/advertisementRightColumn.ts'
        );

        advertisementRightColum();
    }
};

// Rename article list for io analytics and Marfeel
const renameArticleList = async () => {
    const renameArticleListSelectors = document.querySelectorAll('[data-mrf-recirculation]');

    if (renameArticleListSelectors.length > 0) {
        const { RenameArticleList } = await import(
            /* webpackChunkName: 'chunk-renameArticleList' */
            './utils/renameArticleList.ts'
        );
        RenameArticleList();
    }
};

/**
 * Modul loadMore inituje a nastavuje komponentu LoadMore, ktera zajistuje asynchronni nacteni obsahu
 *
 * Dynamicky import modulu, pokud existuje element, na ktery se ma aplikovat
 */
const loadMoreInit = async () => {
    /** @type {NodeListOf<HTMLElement>} */
    const loadMoreElements: NodeListOf<HTMLElement> = document.querySelectorAll('[data-load-more]');

    if (loadMoreElements.length) {
        const { loadMore } = await import(
            /* webpackChunkName: 'chunk-load-more' */
            './components/loadMore.ts'
        );

        loadMore(loadMoreElements);
    }
};

const dsaGuardModeratorInit = async () => {
    const moderatorElements: NodeListOf<HTMLElement> = document.querySelectorAll(
        '[data-dsa-guard-moderator]',
    );

    if (moderatorElements.length > 0) {
        const { dsaGuardModerator } = await import(
            /* webpackChunkName: 'chunk-dsaGuardModerator' */
            '@default/scripts/modules/dsa-daktela/dsaGuardModerator'
        );

        dsaGuardModerator(moderatorElements);
    }
};

const articleListedInit = async () => {
    const articleListedElement: HTMLElement | null =
        document.querySelector('[data-article-listed]');
    if (articleListedElement) {
        const { articleListed } = await import(
            /* webpackChunkName: 'chunk-articleListed' */
            './components/article/listed/articleListed.ts'
        );
        articleListed();
    }
};

/**
 * Načtení všech modulů
 *
 * Všechny funkce pro inicializaci modulů jsou volány paralelně pomocí Promise.all
 */
const speculationAPIInit = async () => {
    const speculationAPIElement: HTMLDivElement | null = document.querySelector(
        '[type="speculationrules"]',
    );

    if (speculationAPIElement) {
        const { speculationAPI } = await import(
            /* webpackChunkName: 'chunk-speculationAPI' */
            './components/speculationAPI.ts'
        );

        speculationAPI();
    }
};

// Pomocné fce pro vývoj a optimalizaci
const devKitInit = async () => {
    if (
        window.location.href.includes('local.cnci.cz') ||
        window.location.href.includes('nocache&CNCdevKit')
    ) {
        const { devKit } = await import(
            /* webpackChunkName: 'chunk-devKit' */
            './components/devKit.ts'
        );

        devKit();
    }
};

const carouselBannersInit = async () => {
    const carouselBannersElements: NodeListOf<HTMLElement> | null = document.querySelectorAll('[data-carousel-banners]');
    if (carouselBannersElements) {
        const { carouselBannersGSAP } = await import(
            /* webpackChunkName: 'chunk-carouselBannersGSAP' */
            './components/carouselBannersGSAP.ts'
        );
        carouselBannersGSAP(carouselBannersElements);
    }
}

const modalImageInit = async () => {
    const modalImageElements: NodeListOf<HTMLElement> = document.querySelectorAll('[data-modal-image]');

    if (modalImageElements.length > 0) {
        const { modalImage } = await import(
            /* webpackChunkName: 'chunk-modalImage' */
            './components/modalImage.ts'
        );
        modalImage(modalImageElements);
    }
};

const liveTextInit = async () => {
    const liveTextElement: HTMLElement | null = document.querySelector('[data-live-text]');
    if (liveTextElement) {
        const { liveText } = await import(
            /* webpackChunkName: 'chunk-liveText' */
            './components/liveText.ts'
        );
        liveText();
    }
};

// ACCORDION | Seznam se skrývajícími se tématy
export const accordionInit = async () => {
    const accordionElements: NodeListOf<HTMLDivElement> =
        document.querySelectorAll('[data-accordion]');

    if (accordionElements && accordionElements.length) {
        const { Accordion } = await import(
            /* webpackChunkName: 'chunk-accordion' */
            './components/accordion/index.ts'
        );
        Accordion(accordionElements);
    }
};

Promise.all([
    navigationInit(),
    dynamicNavigationInit(),
    infoStripInit(),
    atomicDesignInit(),
    breakingNewsInit(),
    swiperInit(),
    contentExpanderInit(),
    giftsAIInit(),
    formTextareaInit(),
    tooltipInit(),
    footerLinkListInit(),
    footerInit(),
    articleCardListAutoloadInit(),
    renameArticleList(),
    advertisementRightColumInit(),
    loadMoreInit(),
    dsaGuardModeratorInit(),
    articleListedInit(),
    speculationAPIInit(),
    devKitInit(),
    carouselBannersInit(),
    modalImageInit(),
    liveTextInit(),
    accordionInit(),
]).then(
    () => {
        // console.log('Všechny moduly načteny.');
    },
    () => {
        // console.log('Some modules not loaded');
    },
);
